







import Vue from 'vue';
import { Logo } from '@/components/ds';

export default Vue.extend({
  name: 'ProuniHeader',
  components: { Logo },
});
